import backgroundStyles from './Background.scss';
export const gradientToClassName = (gradient)=>gradient === undefined ? '' : backgroundStyles[`gradient-type-${gradient}`];

//# sourceMappingURL=utils.js.map